import { REMINDERS_PAUSED_REASONS, resolveRemindersPausedReason } from '@shared/core/billing'
import { USER_EVENTS } from '@shared/core/user-events'
import { ALERT_CAMPAIGN_IDS, ALERT_CAMPAIGN_PRIORITIES, ALERT_CAMPAIGN_SEEN_EVENTS } from '../alerts.constants'
import { AlertCampaign, AlertContext } from '../alerts.types'

// Its own seen flag: an owner who saw the quota modal as a free trial, then
// subscribed and canceled, is still owed this one.
export const subscriptionEndedModalCampaign: AlertCampaign = {
  id: ALERT_CAMPAIGN_IDS.SUBSCRIPTION_ENDED_REMINDERS,
  priority: ALERT_CAMPAIGN_PRIORITIES.SUBSCRIPTION_ENDED_REMINDERS,
  seenEventName: ALERT_CAMPAIGN_SEEN_EVENTS[ALERT_CAMPAIGN_IDS.SUBSCRIPTION_ENDED_REMINDERS],
  isEligible: (context) => isOwedSubscriptionEndedModal(context) && context.pausedReminders.isReady,
}

export function isAwaitingSubscriptionEndedData(context: AlertContext): boolean {
  return isOwedSubscriptionEndedModal(context) && !context.pausedReminders.isReady
}

function isOwedSubscriptionEndedModal(context: AlertContext): boolean {
  if (!context.profile) {
    return false
  }

  if (resolveRemindersPausedReason(context.profile) !== REMINDERS_PAUSED_REASONS.subscriptionEnded) {
    return false
  }

  return !context.userEvents.has(USER_EVENTS.SUBSCRIPTION_ENDED_MODAL_SEEN)
}
